"use client";

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import type { CategoryNode } from "@/lib/types/product";
import { useAuthStore } from "@/stores/authStore";

export function useCategoryTree() {
  const token = useAuthStore((s) => s.accessToken);

  return useQuery({
    queryKey: ["categories", "tree"],
    queryFn: async () => {
      const { data } = await api.get<{ tree: CategoryNode[] }>("/api/categories");

      return data.tree;
    },
    enabled: Boolean(token),
  });
}
